import React, { useState, useEffect, useRef } from "react";
import { withRouter } from "react-router";
import { useDictionary } from "hooks";
import { COLUMN_HEADER_KEYS } from "globals/constants";
import BasePadding from "@cayuse/shared-react.components.base-padding";
import ConfirmationModal from "components/ConfirmationModal";
import SectionHeader from "@cayuse/shared-react.components.section-header";
import VerticalSpacing from "@cayuse/shared-react.components.vertical-spacing";
import CertificationTextView from "components/CertificationText";
import Table from "components/Table";

import styles from "./styles.css";


/* todo: scrub for dictionary entries */
const CertificationTextMainView = props => {
	const [ isNavigation, setNavigation ] = useState(false);
	const [ isDirty, setDirty ] = useState(false);
	const dictionary = useDictionary("certificationText");
	const unblockHandle = useRef();
	const navigationHandle = useRef();

	useEffect(() => {
		return () => {
			unblockHandle.current && unblockHandle.current();
		};
	}, []);

	useEffect(() => { /* todo: refactor to use useConfirmNavigation hook */
		if (unblockHandle.current) {
			unblockHandle.current();
		}
		if (isDirty) {
			unblockHandle.current = props.history.block(targetLocation => {
				setNavigation(true);
				navigationHandle.current = (() => {
					unblockHandle.current && unblockHandle.current();
					props.history.push(targetLocation);
				});

				return false;
			});
		}
	}, [ isDirty, props.history ]);

	return (
		<div>
			<SectionHeader header={dictionary.header} />
			<BasePadding>
				<VerticalSpacing>
					<div className={styles.certificationTextSection}>
						<div className={styles.certificationTextHeader}>
							{dictionary.certificationTextHeader || "Proposal Certification Text"}
						</div>
						<div className={styles.certificationTextContent}>
							<CertificationTextView headerTitle={dictionary.certificationTextHeader || "Proposal Certification Text"} formType={COLUMN_HEADER_KEYS.PROPOSAL} dirtyCallback={setDirty} />
						</div>
					</div>
				</VerticalSpacing>

				<VerticalSpacing>
					<div className={styles.certificationTextSection}>
						<div className={styles.certificationTextHeader}>
							{dictionary.certificationTextHeader || "Award Certification Text"}
						</div>
						<div className={styles.certificationTextContent}>
							<CertificationTextView headerTitle={dictionary.certificationTextHeader || "Award Certification Text"} formType={COLUMN_HEADER_KEYS.AWARD} dirtyCallback={setDirty} />
						</div>
					</div>
				</VerticalSpacing>
			</BasePadding>
			{isNavigation && (
				<ConfirmationModal
					cancelButtonLabel={dictionary.modal.navigation.cancelButtonLabel}
					confirmButtonLabel={dictionary.modal.navigation.confirmButtonLabel}
					icon="file-alt"
					message={dictionary.modal.navigation.message}
					onCancel={() => {
						setNavigation(false);
					}}
					title={dictionary.modal.navigation.title}
					visible={true}
					onConfirm={() => {
						setNavigation(false);
						navigationHandle.current && navigationHandle.current();
					}}
				/>
			)}
		</div>
	);
};

export default withRouter(CertificationTextMainView);
